import api from '../services/api';
import { isAccessTokenValid } from './AuthController';

export const getAllPanicLog = async () => {
    try {
        await isAccessTokenValid();
        const response = await api.get('/panic-log');
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const getPanicLogByID = async (id) => {
    try {
        await isAccessTokenValid();
        const response = await api.get(`/panic-log/${id}`);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};

export const updatePanicLog = async (id, data) => {
    try {
        await isAccessTokenValid();
        const response = await api.put(`/panic-log/${id}`, data);
        return response.data.data;
    } catch (error) {
        throw error.response?.data || error.message;
    };
};
